
        import { renderPinsCounter } from './src/components/PinsCounterScript.tsx';
        renderPinsCounter();
      